export default {
  '1': {
    index: '1',
    name: '站点首页',
    path: '/backend/user'
  },
  '2-1': {
    index: '2-1',
    name: '网站信息',
    path: '/backend/user/siteinfo'
  },
  '2-2': {
    index: '2-2',
    name: 'SEO设置',
    path: '/backend/user/siteseo'
  },
  '2-3-1': {
    index: '2-3-1',
    name: '站点代码',
    path: '/backend/user/codemanagement/sitecode'
  },
  '2-3-2': {
    index: '2-3-2',
    name: '页面代码',
    path: '/backend/user/codemanagement/pagecode'
  },
  '3': {
    index: '3',
    name: '页面管理',
    path: '/backend/user/pages'
  },
  '4': {
    index: '4',
    name: '系统管理',
    path: '/backend/user/system',
    children: [
      {
        name: '系统分类',
        path: '/backend/user/system/category',
        id: 'UserSystemCategory'
      },
      {
        name: '文章系统列表',
        path: '/backend/user/system/article-list',
        id: 'UserSystemArticleList'
      },
      {
        name: '文章系统编辑',
        path: '/backend/user/system/article-item',
        id: 'UserSystemArticleItem'
      },
      {
        name: '文章系统回收站',
        path: '/backend/user/system/article-refuse',
        id: 'UserSystemArticleRefuse'
      },
      {
        name: '产品系统列表',
        path: '/backend/user/system/product-list',
        id: 'UserSystemProductList'
      },
      {
        name: '产品系统编辑',
        path: '/backend/user/system/product-item',
        id: 'UserSystemProductItem'
      },
      {
        name: '产品系统回收站',
        path: '/backend/user/system/product-refuse',
        id: 'UserSystemProductRefuse'
      },
      {
        name: '下载系统列表',
        path: '/backend/user/system/download-list',
        id: 'UserSystemDownloadList'
      },
      {
        name: '下载内容编辑',
        path: '/backend/user/system/download-item',
        id: 'UserSystemDownloadItem'
      },
      {
        name: '下载属性设置',
        path: '/backend/user/system/download-attr',
        id: 'UserSystemDownloadAttr'
      },
      {
        name: '下载系统回收站',
        path: '/backend/user/system/download-refuse',
        id: 'UserSystemDownloadRefuse'
      },
      {
        name: 'FAQ系统列表',
        path: '/backend/user/system/faq-list',
        id: 'UserSystemFaqList'
      },
      {
        name: 'FAQ系统编辑',
        path: '/backend/user/system/faq-item',
        id: 'UserSystemFaqItem'
      },
      {
        name: 'FAQ系统回收站',
        path: '/backend/user/system/faq-refuse',
        id: 'UserSystemFaqRefuse'
      },
      {
        name: '信息系统列表',
        path: '/backend/user/system/information-list',
        id: 'UserSystemInformationList'
      },
      {
        name: '信息系统内容编辑',
        path: '/backend/user/system/information-item',
        id: 'UserSystemInformationItem'
      },
      {
        name: '信息系统属性设置',
        path: '/backend/user/system/information-attr',
        id: 'UserSystemInformationAttr'
      },
      {
        name: '信息系统回收站',
        path: '/backend/user/system/information-refuse',
        id: 'UserSystemInformationRefuse'
      },
      {
        name: '产品表格系统列表',
        path: '/backend/user/system/pdtable-list',
        id: 'UserSystemPdtableList'
      },
      {
        name: '产品表格系统内容编辑',
        path: '/backend/user/system/pdtable-item',
        id: 'UserSystemPdtableItem'
      },
      {
        name: '产品表格系统属性设置',
        path: '/backend/user/system/pdtable-attr',
        id: 'UserSystemPdtableAttr'
      },
      {
        name: '产品表格系统回收站',
        path: '/backend/user/system/pdtable-refuse',
        id: 'UserSystemPdtableRefuse'
      }
    ]
  },
  '5-1': {
    index: '5-1',
    name: '页面提交表单',
    path: '/backend/user/form',
    children: [
      {
        name: '页面提交表单数据列表',
        path: '/backend/user/form/infolist',
        id: 'UserFormInfo'
      }
    ]
  },
  '5-2': {
    index: '5-2',
    name: '系统提交表单',
    path: '/backend/user/sysform',
    children: [
      {
        name: '系统提交表单数据列表',
        path: '/backend/user/form/sysinfolist',
        id: 'UserSysFormInfo'
      }
    ]
  },
  '6-1': {
    index: '6-1',
    name: '资源库',
    path: '/backend/user/repertory'
  },
  '6-2': {
    index: '6-2',
    name: '资源库标签',
    path: '/backend/user/repertory/label'
  },
  '6-4': {
    index: '6-4',
    name: '水印设置',
    path: '/backend/user/repertory/watermark'
  },
  '6-3': {
    index: '6-3',
    name: '资源回收站',
    path: '/backend/user/repertory/refuse'
  },
  '7-1': {
    index: '7-1',
    name: '域名设置',
    path: '/backend/user/host/domain'
  },
  '7-2': {
    index: '7-2',
    name: '整站设置',
    path: '/backend/user/host/setup'
  },
  '7-3': {
    index: '7-3',
    name: '黑/白名单',
    path: '/backend/user/host/hostip'
  },
  '7-4': {
    index: '7-4',
    name: '消息通知',
    path: '/backend/user/host/messagenotify'
  },
  '7-5': {
    index: '7-5',
    name: '关键词过滤',
    path: '/backend/user/host/adwords'
  },
  '8': {
    index: '8',
    name: '操作日志',
    path: '/backend/user/operate/log'
  },
  '9': {
    index: '9',
    name: '推广管理',
    path: '/backend/user/promotion'
  },
  '10': {
    index: '10',
    name: '虚拟目录',
    path: '/backend/user/virtualroot'
  },
  '11': {
    index: '11',
    name: '备份管理',
    path: '/backend/user/backuprestore'
  }
}



// WEBPACK FOOTER //
// ./src/config/menu.js